export const courses = [
  {
    title: "Algorithmic Toolbox",
    category: "Theory",
    institution: "UC San Diego",
    description: "Offered by the University of California San Diego, this course covers essential algorithmic techniques and problem-solving strategies.",
    certificateLink: "https://www.coursera.org/account/accomplishments/verify/LD8BW43NMZLY",
    icon: "📘",
  },
  {
    title: "Neural Networks and Deep Learning",
    category: "AI/ML",
    institution: "DeepLearning.AI",
    description: "The foundational course of the Deep Learning Specialization by DeepLearning.AI, covering the fundamentals of neural networks.",
    certificateLink: "https://www.coursera.org/account/accomplishments/verify/9PPKY9NA4BJF",
    icon: "🤖",
  },
];
